import { cn } from '../lib/utils';

/**
 * "apis" wordmark: a brand-yellow hexagon mark (apis = bee) + the lowercase name.
 * Brand yellow is used only for identity moments (DESIGN.md §2).
 */
export function LogoMark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 32 32" aria-hidden className={cn('h-8 w-8 shrink-0', className)}>
      <rect width="32" height="32" rx="8" fill="var(--brand)" />
      <path
        d="M16 7.5 23.4 11.75v8.5L16 24.5l-7.4-4.25v-8.5L16 7.5Z"
        fill="none"
        stroke="var(--brand-ink)"
        strokeWidth="2.25"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function Logo({ className, label = 'apis' }: { className?: string; label?: string }) {
  return (
    <span className={cn('inline-flex items-center gap-2', className)}>
      <LogoMark />
      <span className="text-lg font-semibold tracking-tight text-[var(--ink)]">{label}</span>
    </span>
  );
}
